import { TratamientoAdminItem } from "./TratamientoAdminItem";
import {
  Outlet,
  Link,
  useLoaderData,
  NavLink
} from "react-router-dom";
import { useState, useEffect } from "react";
import * as API from "../services/tratamientosAdmin";
import { FormatDate } from "../components/documentacion/FormatDate";

export function TratamientoAdminList(props) {
  const [tratamientos, setTratamiento] = useState([]);
  const treatmentStringList = props.list.toString();
  
  // Objeto que mapea los valores de estado a los textos deseados
  const estadoTextos = {
    'seguimiento': 'En seguimiento',
    'fin-con-consumo': 'Finaliza con consumo',
    'fin-sin-consumo': 'Finaliza sin consumo',
    'alta-sin-consumo': 'Alta anticipada sin consumo',
    'alta-con-consumo': 'Alta anticipada con consumo',
    'aband-mala-evol': 'Abandona con mala evolución',
    'aband-buena-evol': 'Abandona con buena evolución',
    'recaida-otro-centro': 'Recaída, fue a otro centro',
    'recaida-tavad': 'Recaída, reingresó en TAVAD',
    'recaida-no-volvio': 'Recaída, no volvió al tratamiento',
    'no-se-sabe': 'No se sabe nada del paciente',
    'defuncion': 'Defunción',
    'carcel': 'Cárcel',
    'enf-grave': 'Enfermedad grave',
    'ning-sesion': 'No realizó ninguna sesión',
    'finalizo-el-tratamiento-con-consumo' : 'Finaliza con consumo',
    'finalizo-el-tratamiento-sin-consumo' : 'Finaliza sin consumo',
    'sin-seguimiento' : 'Sin seguimiento',
  };

  const capitalizeFirstLetter = (string) => {
    // Reemplazar guiones con espacios y luego capitalizar la primera letra
    const stringWithSpaces = string.replace(/-/g, ' ');
    return stringWithSpaces.charAt(0).toUpperCase() + stringWithSpaces.slice(1);
  };

  useEffect(() => {
    API.getTratamientoByIds(treatmentStringList).then(setTratamiento).catch(console.log);
  }, [treatmentStringList]);
  return (
    <>
      {tratamientos === 0 ? (
        <div>Loading...</div>
      ) : (
        <>
        <ul className="treatment-list">
        {console.log(tratamientos)}
          {tratamientos.map((tratamiento) => (
            <li key={tratamiento.id}>
              <Link to={`tratamientos/${tratamiento.id}`}>
              {FormatDate(tratamiento.meta?.fecha)} - {estadoTextos[tratamiento.meta?.estado] || capitalizeFirstLetter(tratamiento.meta?.estado)}
              </Link>
            </li>
          ))}
        </ul>
        <br></br>
        </>
      )}
    </>
  );
}